// extracted by mini-css-extract-plugin
export default {"associateUserImage":"userProfile_associateUserImage__2Ut+j","editIcon":"userProfile_editIcon__dafRm"};